import { useEffect, useRef } from "react";

const Head = ({ children = [] }) => {
  const elementsList = useRef([]);

  const createElementsList = () => {
    let childrenArr = Array.isArray(children) ? children : [children];
    let container = [];

    childrenArr.forEach(({ props, type }) => {
      let child;
      child = document.createElement(type);
      Object.assign(child, props);
      container = [...container, child];
    });
    return container;
  };

  useEffect(() => {
    elementsList.current = createElementsList();

    elementsList.current.forEach((element) =>
      document.head.appendChild(element)
    );
    return () => {
      elementsList.current.forEach((element) =>
        document.head.removeChild(element)
      );
    };
  }, []);

  return null;
};

export default Head;
